export default "__VITE_ASSET__Bx6OacL4__"